export default {"src":"/_next/static/media/0xbfd291da8a403daaf7e5e9dc1ec0aceacd4848b9.e0a56871.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};